import { render, staticRenderFns } from "./UserActions.vue?vue&type=template&id=4b1f1099&"
import script from "./UserActions.ts?vue&type=script&lang=ts&"
export * from "./UserActions.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports